<ng-container *ngIf="(unsecuredStatus$ | async)?.isUnsecured">
  <ng-container *ngIf="data">
    <span *ngIf="!copyToClipboard" class="c-field-value c-field-value--key-info">
      <ng-container *ngIf="tmpl; else default" [ngTemplateOutlet]="tmpl"></ng-container>
    </span>
    <gtd-ui-field-default-string-whitespace-or-empty-with-copy
      *ngIf="copyToClipboard"
      [data]="data"
      [length]="stringWithCopyFieldLength"
      className="d-flex"
    ></gtd-ui-field-default-string-whitespace-or-empty-with-copy>
  </ng-container>
  <gtd-ui-field-empty-component *ngIf="!data"></gtd-ui-field-empty-component>
</ng-container>
<ng-container *ngIf="!(unsecuredStatus$ | async)?.isUnsecured">
  <span class="c-field-value c-field-value--key-protected" (click)="enableUnsecuredMode()">
    <span class="c-field-value__text">{{ getDotsString() }}</span>
  </span>
</ng-container>

<ng-template #default>
  <gtd-ui-field-default-string-whitespace-or-empty
    *ngIf="whitespaceLength"
    [data]="data"
    [length]="whitespaceLength"
  ></gtd-ui-field-default-string-whitespace-or-empty>
  <span *ngIf="!whitespaceLength" class="c-field-value__text">{{ data }}</span>
</ng-template>
